import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { SelectField } from '@unite-us/app-components';
import { filterServiceTypeOptions } from '../utils';

class ServiceTypeSelectField extends Component {
  constructor(props) {
    super(props);

    this.loadOptions = this.loadOptions.bind(this);
    this.resetOptions = this.resetOptions.bind(this);
  }

  loadOptions(search) {
    const { options } = this.props;
    const filtered = filterServiceTypeOptions(options, search);
    return new Promise((resolve) => {
      resolve({
        options: filtered,
      });
    });
  }

  resetOptions() {
    const { field, touch } = this.props;

    touch(field.name);

    if (this.selectField && this.selectField.choices && this.selectField.choices.input) {
      this.selectField.choices.input.value = '';
    }

    if (this.selectField && this.selectField.onSearch) {
      this.selectField.onSearch({ detail: { value: '' } });
    }
  }

  render() {
    const { field, registerField, ...props } = this.props;

    const fieldProps = _.isEmpty(field) ? {} : {
      field: {
        ...field,
        onBlur: this.resetOptions,
      },
    };

    const setRef = (node) => {
      this.selectField = node;
      registerField(node);
    };

    return (
      <SelectField
        {...props}
        {...fieldProps}
        disabled_prop={this.props.disabled}
        loadOptions={this.loadOptions}
        ref={setRef}
      />
    );
  }
}

ServiceTypeSelectField.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  field: PropTypes.object.isRequired,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  registerField: PropTypes.func.isRequired,
  searchChoices: PropTypes.bool,
  searchPlaceholderValue: PropTypes.string,
  touch: PropTypes.func.isRequired,
  validations: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

ServiceTypeSelectField.defaultProps = {
  className: '',
  id: '',
  inline: false,
  label: 'Service Type',
  labelKey: 'name',
  onChange: _.noop,
  options: [],
  placeholder: '',
  searchChoices: true,
  searchPlaceholderValue: '',
  valueKey: 'id',
};

export default ServiceTypeSelectField;
